import { get, getRawValue } from '../../utils/get';
import { CONTEXT_PROPS } from '../../types/ContextProps';
import { getKeys, siteIDs, hasMissingSchemaVariables, } from '../../adapters/utils';
var IDs = {
    SITE_NAME: 'site.name',
    INDEX_SITE: 'site.index',
    INDEX_PAGE: 'page.index',
    TITLE: 'post.title',
    HEADLINE: 'post.headline',
    CATEGORY_NAME: 'post.category.name',
    CONTENT: 'post.content',
    CONTENT_FULL: 'post.content.full',
    COMMENT_AMOUNT: 'post.comments.amount',
    LIKE_AMOUNT: 'post.likes.amount',
    VIEW_AMOUNT: 'post.views.amount',
    COVER_IMAGE: 'post.cover.image',
    COVER_IMAGE_HEIGHT: 'post.cover.image.height',
    COVER_IMAGE_WIDTH: 'post.cover.image.width',
    VIDEO: 'post.video',
    VIDEO_HEIGHT: 'post.video.height',
    VIDEO_WIDTH: 'post.video.width',
    POST_PAGE_URL: 'post.url',
    AUTHOR: 'post.author',
    AUTHOR_PROFILE_URL: 'post.author.profile.url',
    AUTHOR_PROFILE_IMAGE: 'post.author.profile.image',
    PUBLISH_DATE: 'post.publish.date',
    LAST_MODIFIED_DATE: 'post.modified.date',
    SD_DISABLE_SCHEMA: 'forum-post.disable-schema',
};
var userVisible = [
    IDs.TITLE,
    IDs.CONTENT,
    IDs.COMMENT_AMOUNT,
    IDs.LIKE_AMOUNT,
    IDs.VIEW_AMOUNT,
    IDs.CATEGORY_NAME,
    IDs.POST_PAGE_URL,
    IDs.AUTHOR,
    IDs.SITE_NAME,
    IDs.PUBLISH_DATE,
    IDs.LAST_MODIFIED_DATE,
    IDs.COVER_IMAGE,
];
var userVisibleSdOnly = [
    IDs.COVER_IMAGE_HEIGHT,
    IDs.COVER_IMAGE_WIDTH,
    IDs.AUTHOR_PROFILE_URL,
    IDs.AUTHOR_PROFILE_IMAGE,
];
var requiredSchemaVariables = [siteIDs.BUSINESS_LOGO, siteIDs.SITE_NAME];
var SchemaTypes = {
    FORUM_POST: 'forum-post-preset',
};
export default {
    IDs: IDs,
    requiredSchemaVariables: requiredSchemaVariables,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var postContent = get(item, 'post.contentText');
        return _a = {},
            _a[IDs.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME),
            _a[IDs.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE),
            _a[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE),
            _a[IDs.TITLE] = get(item, 'post.title'),
            _a[IDs.HEADLINE] = get(item, 'post.title').substring(0, 110),
            _a[IDs.CATEGORY_NAME] = get(item, 'post.category.label'),
            _a[IDs.CONTENT_FULL] = postContent,
            _a[IDs.CONTENT] = postContent.substring(0, 300),
            _a[IDs.LIKE_AMOUNT] = get(item, 'post.likeCount'),
            _a[IDs.VIEW_AMOUNT] = get(item, 'post.viewCount'),
            _a[IDs.COMMENT_AMOUNT] = get(item, 'post.totalComments'),
            _a[IDs.COVER_IMAGE] = getRawValue(item, 'post.images.0.src') ||
                getRawValue(item, 'post.videos.0.src') ||
                '',
            _a[IDs.COVER_IMAGE_HEIGHT] = getRawValue(item, 'post.images.0.height') ||
                getRawValue(item, 'post.videos.0.height') ||
                '',
            _a[IDs.COVER_IMAGE_WIDTH] = getRawValue(item, 'post.images.0.width') ||
                getRawValue(item, 'post.videos.0.width') ||
                '',
            _a[IDs.VIDEO] = getRawValue(item, 'post.videos.0.videoUrl') || '',
            _a[IDs.VIDEO_HEIGHT] = getRawValue(item, 'post.videos.0.height') || '',
            _a[IDs.VIDEO_WIDTH] = getRawValue(item, 'post.videos.0.width') || '',
            _a[IDs.POST_PAGE_URL] = get(item, 'post.refersTo'),
            _a[IDs.AUTHOR] = get(item, 'post.owner.name'),
            _a[IDs.AUTHOR_PROFILE_URL] = get(item, 'post.owner.profile.url'),
            _a[IDs.AUTHOR_PROFILE_IMAGE] = get(item, 'post.owner.image'),
            _a[IDs.PUBLISH_DATE] = get(item, 'post.createdDate'),
            _a[IDs.LAST_MODIFIED_DATE] = get(item, 'post.editedDate') || get(item, 'post.createdDate'),
            _a[IDs.SD_DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a;
    },
    getLegacySeoBlob: function () { },
    getBiData: function () {
        return {};
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
};
